import { nextTick, App } from 'vue'

export default function useDragWindowDirective (app: App): void {
  app.directive('drag-window', async (el) => {
    await nextTick()

    const modal = el
    const header = el.getElementsByClassName('drag-title')[0]
    if (!header) return

    header.style.cursor = 'move'

    header.onpointerdown = (e: { clientX: number; clientY: number; pointerId: number }) => {
      const startX = e.clientX
      const startY = e.clientY
      const initialModalLeft = modal.offsetLeft
      const initialModalTop = modal.offsetTop
      header.setPointerCapture(e.pointerId)

      el.onpointermove = (event: { clientX: number; clientY: number }) => {
        const endX = event.clientX
        const endY = event.clientY

        const newLeft = initialModalLeft + (endX - startX)
        const newTop = initialModalTop + (endY - startY)

        modal.style.left = newLeft + 'px'
        modal.style.top = newTop + 'px'
      }
      el.onpointerup = () => {
        el.onpointermove = null
        el.onpointerup = null
        header.releasePointerCapture(e.pointerId)
      }
    }
  })
}
